import { MutationTree } from 'vuex';
import { AnnouncementState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<AnnouncementState> = {
	SET_ANNOUNCEMENTS(state: AnnouncementState, announcements: Announcement[]) {
		Vue.set(state, 'announcements', announcements);
	},

	ADD_ANNOUNCEMENT(state: AnnouncementState, newAnnouncement: Announcement): void {
		Vue.set(state, 'announcements', [...state.announcements, newAnnouncement]);
	},

	DELETE_ANNOUNCEMENT(state: AnnouncementState, announcementId: number): void {
		Vue.set(state, 'announcements', state.announcements.filter(announcement => announcement.id !== announcementId));
	}
};